module.exports = __webpack_public_path__ + "bin/ca49bba4ee5bc19ee6dc0545e112b3e8.svg";